
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AuthForm } from "@/components/auth/AuthForm";
import { SocialLoginOptions } from "@/components/auth/SocialLoginOptions";

interface AuthTabsProps {
  activeTab: "signin" | "signup" | "forgotPassword" | "resetPassword";
  onTabChange: (value: string) => void;
  onForgotPassword: () => void;
}

export function AuthTabs({ activeTab, onTabChange, onForgotPassword }: AuthTabsProps) {
  // Only render the tab interface if we're in signin or signup mode
  if (activeTab === "forgotPassword" || activeTab === "resetPassword") {
    return null;
  }

  return (
    <Tabs defaultValue={activeTab} onValueChange={onTabChange}>
      <TabsList className="grid w-full grid-cols-2 mb-6">
        <TabsTrigger value="signin">Sign In</TabsTrigger>
        <TabsTrigger value="signup">Sign Up</TabsTrigger>
      </TabsList>
      
      <SocialLoginOptions />
      
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">Or continue with</span>
        </div>
      </div>
      
      <TabsContent value="signin">
        <AuthForm
          isSignUp={false}
          onToggleMode={() => onTabChange("signup")}
          onForgotPassword={onForgotPassword}
        />
      </TabsContent>
      
      <TabsContent value="signup">
        <AuthForm 
          isSignUp={true}
          onToggleMode={() => onTabChange("signin")}
          onForgotPassword={onForgotPassword}
        />
        <p className="text-xs text-center text-muted-foreground mt-6">
          By signing up, you agree to our{" "}
          <a href="/privacy-terms" className="underline hover:text-primary">
            Terms of Service and Privacy Policy
          </a>
        </p>
      </TabsContent>
    </Tabs>
  );
}
